import { useEffect, useState } from 'react'
import { api } from './api.js'

const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']

export default function Creneaux({ agenda, choisi, onChoix }) {
  const [data, setData] = useState(null)
  useEffect(() => { api.slots(agenda).then(setData).catch(() => setData({ days: [] })) }, [agenda])
  if (!data) return <p>Chargement des créneaux…</p>

  return (
    <div className="creneaux">
      <p className="chapo">Rendez-vous de {data.duration} minutes. Choisissez ce qui vous arrange.</p>
      <div className="semaine">
        {data.days.map((d) => {
          const date = new Date(d.day + 'T12:00:00')
          const libres = d.slots.filter((s) => s.free > 0)
          return (
            <div className="jour" key={d.day}>
              <h3>{JOURS[date.getDay()]} {date.getDate()}/{date.getMonth() + 1}</h3>
              {libres.length ? libres.map((s) => (
                <button key={s.time}
                        className={choisi?.day === d.day && choisi?.time === s.time ? 'creneau on' : 'creneau'}
                        aria-pressed={choisi?.day === d.day && choisi?.time === s.time}
                        onClick={() => onChoix({ day: d.day, time: s.time })}>
                  {s.time}
                </button>
              )) : <p className="vide">complet</p>}
            </div>
          )
        })}
      </div>
    </div>
  )
}
